if (!customElements.get('wv-offer-selector')) {
  customElements.define(
    'wv-offer-selector',
    class WvOfferSelector extends HTMLElement {
      constructor() {
        super();

        const dataScript = this.querySelector('[data-wv-offer-data]');
        if (!dataScript) return;

        try {
          this.data = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.error('wv-offer-selector: invalid data', e);
          return;
        }

        this.cardButtons = Array.from(this.querySelectorAll('.wv-offer__card'));
        this.swatchButtons = Array.from(this.querySelectorAll('.wv-offer__swatch'));
        this.twinNote = this.querySelector('[data-wv-twin-note]');
        this.priceEl = this.data.priceSelector ? document.querySelector(this.data.priceSelector) : null;

        this.form = document.getElementById(this.data.productFormId);
        this.variantInput = this.form ? this.form.querySelector('[name="id"]') : null;
        this.submitButton = this.form ? this.form.querySelector('[type="submit"]') : null;

        this.selectedOffer = 'launch';
        const firstAvailable = this.swatchButtons.find((btn) => !btn.disabled);
        this.selectedColour = firstAvailable ? firstAvailable.dataset.colour : null;

        this.cardButtons.forEach((btn) => {
          btn.addEventListener('click', () => this.selectOffer(btn.dataset.offer));
        });

        this.swatchButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.disabled) return;
            this.selectColour(btn.dataset.colour);
          });
        });

        const root = this.closest('.product__info-container') || document.querySelector('.product');
        if (root) root.classList.add('wv-offer-selector-active');

        this.render();
      }

      selectOffer(offer) {
        if (offer !== 'launch' && offer !== 'twin') return;
        this.selectedOffer = offer;
        this.render();
      }

      selectColour(colour) {
        this.selectedColour = colour;
        this.render();
      }

      currentOfferData() {
        return this.data[this.selectedOffer];
      }

      render() {
        this.cardButtons.forEach((btn) => {
          const isSelected = btn.dataset.offer === this.selectedOffer;
          btn.classList.toggle('wv-offer__card--selected', isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        const offerData = this.currentOfferData();

        this.swatchButtons.forEach((btn) => {
          const colour = btn.dataset.colour;
          const availableForOffer = offerData && offerData.variants && offerData.variants[colour];
          btn.disabled = !availableForOffer;
          const swatchSelected = colour === this.selectedColour;
          btn.classList.toggle('wv-offer__swatch--selected', swatchSelected);
          btn.setAttribute('aria-pressed', swatchSelected ? 'true' : 'false');
        });

        if (offerData && (!this.selectedColour || !offerData.variants[this.selectedColour])) {
          const fallback = this.swatchButtons.find((btn) => !btn.disabled);
          this.selectedColour = fallback ? fallback.dataset.colour : null;
          this.swatchButtons.forEach((btn) => {
            const fallbackSelected = btn.dataset.colour === this.selectedColour;
            btn.classList.toggle('wv-offer__swatch--selected', fallbackSelected);
            btn.setAttribute('aria-pressed', fallbackSelected ? 'true' : 'false');
          });
        }

        if (this.priceEl && offerData) {
          this.priceEl.textContent = offerData.priceFormatted;
        }

        if (this.twinNote) {
          this.twinNote.hidden = this.selectedOffer !== 'twin';
        }

        const variantId =
          offerData && this.selectedColour ? offerData.variants[this.selectedColour] : null;

        if (this.variantInput) {
          if (variantId) {
            this.variantInput.value = variantId;
            this.variantInput.disabled = false;
          } else {
            this.variantInput.disabled = true;
          }
        }

        if (this.submitButton) {
          this.submitButton.toggleAttribute('disabled', !variantId);
        }
      }
    }
  );
}
